import {RFValue} from 'react-native-responsive-fontsize';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import styled from 'styled-components/native';

export const Container = styled.View`
  padding: ${RFValue(24)}px;
`;

export const Header = styled.View`
  margin-bottom: ${RFValue(24)}px;
`;

export const Title = styled.Text`
  font-size: ${RFValue(20)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const Description = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const SupportOption = styled.View`
  flex-direction: row;
  align-items: center;
  border-radius: ${RFValue(12)}px;
`;

export const SupportOptionIcon = styled(FontAwesome)`
  font-size: ${RFValue(16)}px;
  margin-right: ${RFValue(8)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const SupportOptionContent = styled.View`
  flex: 1;
`;

export const SupportOptionTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const SupportOptionDescription = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const SupportOptionButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  padding: ${RFValue(8)}px ${RFValue(16)}px;
  border-radius: ${RFValue(8)}px;
`;

export const SupportOptionButtonText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  font-weight: 600;
`;
